(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = true;
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      this.header.classList.add('shopify-section-header-sticky');

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.addEventListener('preventHeaderReveal', () => {});
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop) {
        this.header.classList.add('scrolled-past-header');
      } else if (scrollTop <= 0) {
        this.header.classList.remove('scrolled-past-header');
      }
      this.currentScrollTop = scrollTop;
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ── FORCE vertical centering after ALL stylesheets load ── */
  function forceHeaderCenter() {
    var header = document.querySelector('sticky-header .header, .header-wrapper .header');
    if (!header) return;
    header.style.setProperty('align-items', 'center', 'important');
    header.style.setProperty('min-height', '72px', 'important');
    header.style.setProperty('padding-top', '0', 'important');
    header.style.setProperty('padding-bottom', '0', 'important');

    var cells = header.children;
    for (var i = 0; i < cells.length; i++) {
      cells[i].style.setProperty('align-self', 'center', 'important');
      cells[i].style.setProperty('margin-top', 'auto', 'important');
      cells[i].style.setProperty('margin-bottom', 'auto', 'important');
    }
  }
  // Run on DOMContentLoaded, on load (after stylesheets), and on scroll
  document.addEventListener('DOMContentLoaded', forceHeaderCenter);
  window.addEventListener('load', forceHeaderCenter);

  /* Red-S logo highlight for text logos */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.header__heading-link .h2').forEach(function (el) {
      var text = el.textContent.trim();
      if (/enthusiast/i.test(text)) {
        el.innerHTML = text.replace(
          /^(ENTHU)(S)(IAST)$/i,
          '<span style="color:#f5f5f7">$1</span><span class="logo-s" style="color:#e8361e">$2</span><span style="color:#f5f5f7">$3</span>'
        );
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
